import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { Theme } from '@mui/material';
import type { PropsWithChildren } from 'react';
import React from 'react';
import styled from 'styled-components';
import Typography, {
  TypographyVariant,
} from '../../../../component_library/components/Typography';
import type { ITheme } from '../../../../component_library/styles/theme';
import { BREAKPOINT } from '../../../../component_library/utils/breakpoints';

const ListItem = styled.li({
  all: 'unset',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  '&:not(:last-child)': {
    marginBottom: '16px',
  },
});

interface IProps {
  theme: ITheme;
  muiTheme: Theme;
}

export const CheckmarkBulletRow: React.FC<PropsWithChildren<IProps>> = ({
  theme,
  muiTheme,
  children,
}) => (
  <ListItem>
    <FontAwesomeIcon
      icon={faCheckCircle}
      color={theme.colors.positive}
      style={{ marginRight: '14px', marginTop: '4px' }}
    />
    <Typography
      variant={{
        [BREAKPOINT.DESKTOP]: TypographyVariant.MEDIUM_BODY_REGULAR,
        [BREAKPOINT.TABLET_MINI]: TypographyVariant.SMALL_BODY_REGULAR,
      }}
      muiTheme={muiTheme}
      theme={theme}
    >
      {children}
    </Typography>
  </ListItem>
);
